import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "../lib/data";
import Reveal from "./Reveal";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <Reveal>
            <span className="overline">Nos expertises</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-3 font-display font-extrabold text-ink text-3xl md:text-5xl leading-tight">
              Trois métiers, une seule <span className="gradient-text">urgence</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-4 text-lg text-ink-soft">
              Chaque intervention est menée par un artisan spécialisé, équipé et certifié.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={i * 0.12}>
              <Link
                to={`/${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className="card-soft group block overflow-hidden h-full"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={s.image}
                    alt={`Dépannage ${s.title.toLowerCase()} d'urgence`}
                    loading="lazy"
                    decoding="async"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute top-4 left-4 chip bg-white/90 backdrop-blur">
                    {s.index} · {s.price}
                  </span>
                </div>
                <div className="p-6">
                  <h3 className="font-display font-bold text-ink text-2xl">{s.title}</h3>
                  <p className="mt-2 text-ink-soft leading-relaxed">{s.short}</p>
                  <span className="mt-5 btn-link text-brand">
                    En savoir plus <ArrowRight className="h-4 w-4" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
